export const CLIENT_SEARCH_FILTERS = {
  SPECIALITY_OPTIONS: [
    {
      label: "- Select -",
      value: "",
    },
    {
      label: "Bariatrics",
      value: "Bariatrics",
    },
    {
      label: "Chiropractic",
      value: "Chiropractic",
    },
    {
      label: "Cardiology",
      value: "Cardiology",
    },
    {
      label: "Dermatology",
      value: "Dermatology",
    },
    {
      label: "ENT",
      value: "ENT",
    },
    {
      label: "Endocrinology",
      value: "Endocrinology",
    },
    {
      label: "Family Medicine",
      value: "Family Medicine",
    },
    {
      label: "Geriatrics",
      value: "Geriatrics",
    },
    {
      label: "Gastroenterology",
      value: "Gastroenterology",
    },
    {
      label: "General Surgery",
      value: "General Surgery",
    },
    {
      label: "General Surgery",
      value: "General Surgery",
    },
    {
      label: "Internal Medicine",
      value: "Internal Medicine",
    },
    {
      label: "Nephrology",
      value: "Nephrology",
    },
    {
      label: "Neurology",
      value: "Neurology",
    },
    {
      label: "Orthopedics",
      value: "Orthopedics",
    },
    {
      label: "Pediatrics",
      value: "Pediatrics",
    },
    {
      label: "Psychiatry",
      value: "Psychiatry",
    },
    {
      label: "Pain Medicine",
      value: "Pain Medicine",
    },
    {
      label: "PT",
      value: "PT",
    },
    {
      label: "Pulmonology",
      value: "Pulmonology",
    },
    {
      label: "Podiatry",
      value: "Podiatry",
    },
    {
      label: "Rheumatology",
      value: "Rheumatology",
    },
    {
      label: "Urgent Care",
      value: "Urgent Care",
    },
    {
      label: "Urology",
      value: "Urology",
    },
  ],

  ACCOUNT_OPTIONS: [
    {
      label: "- Select -",
      value: "",
    },
    {
      label: "Trial",
      value: "TRIAL",
    },
    {
      label: "Production",
      value: "PRODUCTION",
    },
    {
      label: "Implementation",
      value: "IMPLEMENTATION",
    },
    {
      label: "Live",
      value: "LIVE",
    },
    {
      label: "Paid",
      value: "PAID",
    },
    {
      label: "InActive",
      value: "INACTIVE",
    },
  ],

  ALERT_OPTIONS: [
    {
      label: "- Select -",
      value: "",
    },
    {
      label: "Red",
      value: "R",
    },
    {
      label: "Green",
      value: "G",
    },
    {
      label: "Yellow",
      value: "Y",
    },
  ],

  HEALTH_SCORE_OPTIONS: [
    {
      label: "- Select -",
      value: "",
    },
    {
      label: "Excellent",
      value: "E",
      color: "#85cb85",
    },
    {
      label: "Good",
      value: "G",
      color: "#c071c0",
    },
    {
      label: "Average ",
      value: "A",
      color: "#5c5cb7",
    },
    {
      label: "Unhealthy",
      value: "U",
      color: "#d8b97f",
    },
    {
      label: "Very Poor",
      value: "VP",
      color: "#d16565",
    },
  ],
  CLIENT_TICKETS_STATUS: [
    {
      label: "All",
      value: "",
    },
    {
      label: "Open",
      value: "O",
    },
    {
      label: "In Progress",
      value: "I",
    },
    {
      label: "Pending On Client",
      value: "Q",
    },
    {
      label: "Resolved",
      value: "R",
    },
  ],
  NEW_PLAN_STATUS_OPTIONS: [
    {
      label: "INPROCESS",
      value: "INPROCESS",
    },
    {
      label: "RESCHEDULED ",
      value: "RESCHEDULED",
    },
    {
      label: "CANCELLED",
      value: "CANCELLED",
    },
    {
      label: "COMPLETED",
      value: "COMPLETED",
    },
    {
      label: "CONFIRMED",
      value: "CONFIRMED",
    },
  ],
  ACCOUNTS: [
    {
      label: "- Select -",
      value: "",
    },
    {
      label: "Trial",
      value: "TRIAL",
    },
    {
      label: "Production",
      value: "PRODUCTION",
    },

    {
      label: "Implementation",
      value: "IMPLEMENTATION",
    },

    {
      label: "Live",
      value: "LIVE",
    },
    {
      label: "InActive",
      value: "INACTIVE",
    },
  ],

  PRODUCTS: [
    {
      label: "- Select -",
      value: "",
    },
    {
      label: "EHR",
      value: "EHR",
    },
    {
      label: "PM",
      value: "PM",
    },
    {
      label: "EHR + PM",
      value: "EHR - PM",
    },
    {
      label: "EHR + PM + RCM",
      value: "All",
    },
  ],
  PRODUCTS_DETAIL: [
    {
      label: "EHR",
      value: "EHR",
    },
    {
      label: "EHR - PM",
      value: "EHR - PM",
    },
    {
      label: "PM",
      value: "PM",
    },
  ],

  NOTE_TYPES: [
    {
      label: "-Select-",
      value: "",
    },
    {
      label: "Implementation Package",
      value: "I",
    },
    {
      label: "Kick Off Call",
      value: "K",
    },
    {
      label: "Training",
      value: "T",
    },
    {
      label: "Other",
      value: "O",
    },
  ],
  PAYMENT_CYCLE: [
    {
      label: "- Select -",
      value: "",
    },
    {
      label: "Monthly",
      value: "MONTHLY",
    },
    {
      label: "Quarterly",
      value: "QUARTERLY",
    },
    {
      label: "Biannualy",
      value: "BIANNUAL",
    },
    {
      label: "Yearly",
      value: "YEARLY",
    },
  ],
  PRICING_MODEL: [
    {
      label: "Per Provider",
      value: "P",
    },
    {
      label: "Flat Fee - Limited Providers",
      value: "F",
    },
    {
      label: "Flat Fee - Unlimited Providers",
      value: "U",
    },
  ],

  CLIENT_COLUMNS: [
    {
      label: "AUTH_ENTITY_SEQ_NUM",
      value: "authEntityId",
    },
    {
      label: "PRACTICE_NAME",
      value: "practiceName",
    },
    {
      label: "ENTITY_SHORT_NAME",
      value: "entityShortName",
    },
    {
      label: "SPECIALITY",
      value: "speciality",
    },
    {
      label: "PRACTICE_EMIL",
      value: "practiceEmail",
    },
    {
      label: "PRACTICE_TEL_NUM",
      value: "PracticeTelNum",
    },
    {
      label: "CONTACT_PERSON",
      value: "contactPerson",
    },
    {
      label: "CHANNEL_PARTNER",
      value: "channelPartner",
    },
    {
      label: "SALES_PERSON",
      value: "salesPeron",
    },

    {
      label: "TRIAL_ACTIVATION_STATUS",
      value: "trialActivationStatus",
    },
    {
      label: "ACCOUNT_TYPE",
      value: "accountType",
    },
  ],

  TIME_ZONE_OPTIONS: [
    {
      label: "- Select -",
      value: "",
    },
    {
      label: "MST",
      value: "MST",
    },
    {
      label: "IST",
      value: "IST",
    },
    {
      label: "CHT",
      value: "CHT",
    },
    {
      label: "HST",
      value: "HST",
    },
    {
      label: "HDT",
      value: "HDT",
    },
    {
      label: "CST",
      value: "CST",
    },
    {
      label: "ICT",
      value: "ICT",
    },
    {
      label: "PST",
      value: "PST",
    },
    {
      label: "EST",
      value: "EST",
    }
  ],
};
